import { Link } from 'react-router-dom';

export default function Logo() {
   return (
      <Link to="/" id="logo">
         <span>L</span>OGO
      </Link>
   );
}